function e(a, t = Number.MIN_SAFE_INTEGER, E = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(a, E));
}
export {
  e as default
};
